import * as swcHelpers from '@swc/helpers';
import { ProductCategory } from '@grandvisionhq/svc-tealium/events';
import { mapProductTypeToProductCategory, formatPrice, mapProductStockToProductStatus } from '@grandvisionhq/svc-tealium/utils';

var DiscountType;
(function(DiscountType) {
    DiscountType["PRODUCT_DISCOUNT"] = "PRODUCT_DISCOUNT";
    DiscountType["CART_DISCOUNT"] = "CART_DISCOUNT";
})(DiscountType || (DiscountType = {}));
const getFinalStockCount = (availability)=>{
    return availability ? Object.entries(availability.channels).reduce((prev, next)=>{
        return prev + next[1].availableQuantity;
    }, 0) : 0;
};
const planeLensTypes = [
    ProductCategory.CONTACT_LENSES,
    ProductCategory.SUN,
    ProductCategory.OPTICS,
    ProductCategory.EYEWEAR, 
];
const mapVisualLineItemProductToTealiumProduct = (lineItems, withIndex)=>{
    const products = {};
    lineItems.forEach((lineItem, index)=>{
        var ref, ref1, ref2, ref3, ref4, ref5;
        const productKey = withIndex ? `${lineItem.sku}#${index}` : lineItem.sku;
        const stockCount = getFinalStockCount(lineItem.availability);
        const lensPackageItem = lineItem.type == 'GLASSES_BUNDLE' && lineItem.bundleChildLineItems ? lineItem.bundleChildLineItems.filter((item)=>item.type == 'PrescriptionGlassPackageOptions'
        ) : [];
        const category = lineItem.type == 'GLASSES_BUNDLE' ? mapProductTypeToProductCategory(lineItem.subProductType) : mapProductTypeToProductCategory(lineItem.productType);
        const productDiscount = (ref = lineItem.unitPrice) === null || ref === void 0 ? void 0 : (ref1 = ref.appliedDiscounts) === null || ref1 === void 0 ? void 0 : ref1.filter((item)=>item.type === 'PRODUCT_DISCOUNT'
        ).reduce((prev, next)=>prev + next.value
        , 0);
        const price = (lineItem === null || lineItem === void 0 ? void 0 : (ref2 = lineItem.unitPrice) === null || ref2 === void 0 ? void 0 : ref2.originalPrice) ? formatPrice((lineItem === null || lineItem === void 0 ? void 0 : (ref3 = lineItem.unitPrice) === null || ref3 === void 0 ? void 0 : ref3.originalPrice) - (productDiscount || 0), true) : '0';
        var ref6;
        const quantityParts = (ref6 = lineItem.quantity.split(':')) !== null && ref6 !== void 0 ? ref6 : [];
        const quantityValue = quantityParts.length > 1 && quantityParts[1] ? quantityParts[1] : '';
        products[productKey] = swcHelpers.objectSpread({
            Category: category
        }, lineItem.productType == 'prescription-glasses' ? {
            FrameType: 'CP',
            LensType: 'RX'
        } : {
            ModelName: lineItem.displayName || '',
            LensType: planeLensTypes.includes(category) ? 'PLANO' : undefined
        }, {
            Price: price,
            PriceFull: formatPrice(((ref4 = lineItem.unitPrice) === null || ref4 === void 0 ? void 0 : ref4.originalPrice) || 0, true)
        }, lensPackageItem.length && lensPackageItem[0] ? {
            LensUPC: lensPackageItem[0].sku
        } : {}, {
            Status: mapProductStockToProductStatus(stockCount, true),
            TaxRate: formatPrice(((ref5 = lineItem.unitPrice) === null || ref5 === void 0 ? void 0 : ref5.taxRate) || 0, false),
            Units: `${quantityValue.trim()}`
        });
    });
    return products;
};
const mapLineItemProductToTealiumProduct = (lineItems, withIndex)=>{
    const products = {};
    lineItems.map((lineItem, index)=>{
        var ref, ref7;
        const key = lineItem.type == 'prescription-glasses' ? lineItem.frame.sku : lineItem.sku;
        const stockCount = getFinalStockCount(lineItem.availability);
        const category = lineItem.productType === 'Frames' || lineItem.productType === 'optical' ? mapProductTypeToProductCategory(lineItem.productType.toLocaleLowerCase()) : mapProductTypeToProductCategory(lineItem.type);
        const itemIndex = withIndex ? `${key}#${index}` : key;
        const productDiscount = (ref = lineItem.price.unit) === null || ref === void 0 ? void 0 : (ref7 = ref.appliedDiscounts) === null || ref7 === void 0 ? void 0 : ref7.filter((item)=>item.type === 'PRODUCT_DISCOUNT'
        ).reduce((prev, next)=>prev + next.value
        , 0);
        const price = lineItem.price.unit.original ? formatPrice(lineItem.price.unit.original - (productDiscount || 0), true) : '0';
        products[itemIndex] = swcHelpers.objectSpread({
            Price: price,
            PriceFull: formatPrice(lineItem.price.unit.original, true),
            Category: category
        }, lineItem.type == 'prescription-glasses' ? {
            FrameType: 'CP',
            LensType: 'RX'
        } : {
            LensType: planeLensTypes.includes(category) ? 'PLANO' : undefined,
            ModelName: `${lineItem.name}`
        }, {
            Status: mapProductStockToProductStatus(stockCount, true),
            Units: `${lineItem.quantity}`,
            TaxRate: formatPrice(lineItem.price.unit.taxRate, false)
        });
    });
    return products;
};
const mapRemovedProductToTealiumProduct = (lineItem)=>{
    const key = lineItem.type == 'prescription-glasses' ? lineItem.frame.sku : lineItem.sku;
    const category = lineItem.productType === 'Frames' ? mapProductTypeToProductCategory(lineItem.productType.toLocaleLowerCase()) : mapProductTypeToProductCategory(lineItem.type);
    return {
        [key]: swcHelpers.objectSpread({
            Category: category
        }, lineItem.type == 'prescription-glasses' ? {
            LensType: 'RX',
            FrameType: 'CP'
        } : {
            LensType: planeLensTypes.includes(category) ? 'PLANO' : undefined
        })
    };
};
const cartToTealiumOrderDiscountInfo = (cart)=>{
    var ref, ref8, ref9;
    const orderDiscount = (ref = cart.prices.appliedDiscounts) === null || ref === void 0 ? void 0 : ref.filter((item)=>item.type === 'CART_DISCOUNT'
    ).reduce((prev, next)=>prev + next.value
    , 0);
    return {
        Order_DiscountAmount: orderDiscount ? `-${formatPrice(orderDiscount, true)}` : '0',
        Order_DiscountCode: ((ref8 = cart.voucherCodes) === null || ref8 === void 0 ? void 0 : ref8.length) ? cart.voucherCodes.join() : '',
        Order_DiscountName: ((ref9 = cart.voucherNames) === null || ref9 === void 0 ? void 0 : ref9.length) ? cart.voucherNames.join() : ''
    };
};
const cartToTealiumPriceInfo = (cart)=>{
    const shippingDiscount = (cart === null || cart === void 0 ? void 0 : cart.prices.shippingDiscount) || 0;
    const products = mapVisualLineItemProductToTealiumProduct(cart.visualLineItems);
    let Order_ProductsAmount = 0;
    Object.values(products).forEach((product)=>{
        Order_ProductsAmount += parseFloat(product.Price) * parseFloat(product.Units);
    });
    return {
        Order_Subtotal: formatPrice(cart.prices.totalPrice - cart.prices.taxPrice - cart.prices.shippingPrice, true),
        Order_Total: formatPrice(cart.prices.totalPrice, true),
        Order_TaxAmount: formatPrice(cart.prices.taxPrice, true),
        Order_ShippingTaxRate: formatPrice(cart.prices.shippingTaxRate, false),
        Order_ShippingDiscount: shippingDiscount ? `-${formatPrice(cart.prices.shippingDiscount, true)}` : '0',
        Order_ShippingAmount: formatPrice(cart.prices.shippingPrice, true),
        Order_ProductsAmount: formatPrice(Order_ProductsAmount, false)
    };
};
const getCartSubscriptionFrequency = (cart)=>{
    if (!cart.hasSubscription) {
        return '0';
    } else {
        const subscriptionProduct = cart.lineItems.filter((item)=>item.type == 'contact-lenses' && 'subscriptionDetails' in item
        )[0];
        if (!subscriptionProduct) {
            return '0';
        } else {
            const subscription = subscriptionProduct.subscriptionDetails;
            if (!(subscription === null || subscription === void 0 ? void 0 : subscription.deliveryInterval)) return '0';
            return convertDaysToMonths(subscription === null || subscription === void 0 ? void 0 : subscription.deliveryInterval).toFixed(1);
        }
    }
};
var ShippingMethod;
(function(ShippingMethod) {
    ShippingMethod["Delivery"] = 'home-delivery';
    ShippingMethod["DeliveryExpress"] = 'home-delivery-express';
    ShippingMethod["NearestPickup"] = 'nearest-pick-up';
    ShippingMethod["Pickup"] = 'pick-up';
    ShippingMethod["PickupPoint"] = 'pick-up-point';
    ShippingMethod["DeliveryPremium"] = 'dpd-priority-delivery';
})(ShippingMethod || (ShippingMethod = {}));
const getCartToTealiumShippingInfo = (shippingMethod)=>({
        Order_ShippingMode: getShippingMode(shippingMethod),
        Order_ShippingType: getShippingType(shippingMethod)
    })
;
const getShippingType = (shippingMethodKey)=>{
    switch(shippingMethodKey){
        case ShippingMethod.Delivery:
        case ShippingMethod.DeliveryPremium:
        case ShippingMethod.DeliveryExpress:
            return 'Home';
        case ShippingMethod.NearestPickup:
        case ShippingMethod.Pickup:
        case ShippingMethod.PickupPoint:
            return 'Store';
        default:
            return 'Home';
    }
};
const getShippingMode = (shippingMethodKey)=>{
    switch(shippingMethodKey){
        case ShippingMethod.DeliveryPremium:
        case ShippingMethod.DeliveryExpress:
            return 'Express';
        case ShippingMethod.NearestPickup:
        case ShippingMethod.Pickup:
        case ShippingMethod.PickupPoint:
            return 'Pick-up-point';
        default:
            return 'Standard';
    }
};
const convertDaysToMonths = (days)=>{
    return days / 30;
};

export { cartToTealiumOrderDiscountInfo, cartToTealiumPriceInfo, getCartSubscriptionFrequency, getCartToTealiumShippingInfo, getFinalStockCount, mapLineItemProductToTealiumProduct, mapRemovedProductToTealiumProduct, mapVisualLineItemProductToTealiumProduct };
//# sourceMappingURL=line-item-to-tealium-product.js.map
